import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

type SimpleRemoveDialogBoxProps = {
  removeDialogOpen: boolean;

  handleRemove: () => void;
  handleDialogClose: () => void;
  title: string;
  contentText: string[];
  textButton: string;
  containedButton: string;
  icon?: React.ReactNode;
};

export const SimpleRemoveDialogBox: React.FC<SimpleRemoveDialogBoxProps> = ({
  removeDialogOpen,
  handleRemove,
  handleDialogClose,
  title,
  contentText,
  textButton,
  containedButton,
  icon
}: SimpleRemoveDialogBoxProps) => {
  return (
    <div>
      <Dialog
        open={removeDialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        data-testid="alert-Dialog-Box"
      >
        <DialogTitle data-testid="alert-dialog-title">{title}</DialogTitle>
        <DialogContent data-testid="alert-dialog-content">
          {contentText.map((item) => (
            <DialogContentText id="alert-dialog-description" key={item}>
              <Typography>{item}</Typography>
            </DialogContentText>
          ))}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleRemove}
            color="secondary"
            variant="text"
            startIcon={icon}
            data-testid="alert-remove-button"
          >
            {textButton}
          </Button>
          <Button
            onClick={handleDialogClose}
            variant="contained"
            color="primary"
            data-testid="alert-cancel-button"
          >
            {containedButton}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
